import { modernWarfareProfile } from '../themeProfiles/modernWarfare';

export const modernWarfareTheme = {
  name: 'modernWarfare',
  colors: {
    primary: '#ff2a6d', // Cyber Pink
    primaryDark: '#d91e5b',
    secondary: '#05d9e8', // Electric Blue
    background: '#05070a',
    backgroundSecondary: 'rgba(5, 7, 10, 0.9)',
    surface: 'rgba(255, 255, 255, 0.03)',
    surfaceHover: 'rgba(255, 255, 255, 0.06)',
    text: '#ffffff',
    textSecondary: '#8b9bb4',
    textMuted: '#5d6b82',
    textDisabled: '#3a4352',
    border: 'rgba(255, 255, 255, 0.2)',
    borderLight: 'rgba(255, 255, 255, 0.08)',
    borderMuted: 'rgba(255, 255, 255, 0.03)',
    error: '#ff4444',
    success: '#00ff88',
    warning: '#ffaa00',
  },
  fonts: {
    body: "'Chakra Petch', sans-serif",
    heading: "'Rajdhani', sans-serif",
  },
  gradients: {
    background: 'radial-gradient(circle at 50% 50%, #1a1f2c 0%, #05070a 100%)',
    surface: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, transparent 50%)',
    primary: 'linear-gradient(135deg, #ff2a6d, #d91e5b)',
    glow: 'radial-gradient(circle at 50% 50%, rgba(255, 42, 109, 0.15) 0%, transparent 70%)',
  },
  shadows: {
    primary: '0 0 20px rgba(255, 42, 109, 0.4)',
    card: '0 8px 32px rgba(0, 0, 0, 0.4)',
    button: '0 0 15px rgba(255, 42, 109, 0.3)',
  },
  animatedBackground: {
    gridColor: 'rgba(5, 217, 232, 0.05)',
    circleColor: '#ff2a6d',
    scanlineColor: '#05d9e8',
  },
  styles: {
    cardBorderRadius: '16px',
    cardBackdrop: 'blur(20px)',
    buttonBorderRadius: '2px',
    headerBackground: 'rgba(5, 7, 10, 0.8)',
    headerBorder: 'rgba(255, 255, 255, 0.08)',
  },
  profile: modernWarfareProfile,
};
